export const PAGE_CONFIG = {
  "title": "Daily",
  "titleCN": "运营总况日报",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/overview/pcConsoleDailyV2",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "tabName": "Overall",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "notificationPath": "/overview/pcConsoleDailyV2",
      "path": "/overview/pcConsoleDailyV2/overall",
      "tabIcon": "chart-map",
      "logConfig": {
        "pageId": "204301",
        "pageName": "dailyV2Overall",
        "extInfo": "dailyV2Overall",
        "pagePath": "/overview/pcConsoleDailyV2/overall"
      },
      "filters": [
        {
          "name": "PcConsoleDailyFilterV2",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/pcConsoleDailyV2",
          "componentList": [
            {
              "name": "KeyMetricTitle",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_daily/country_region_platform",
                  "metric": "dau"
                }
              }
            },
            {
              "name": "PlatformMetricsCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                  "metricsList": [
                    "active_users",
                    "new_users"
                  ]
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PlatformCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "active_users",
                                  "enName": "DAU",
                                  "cnName": "日活跃",
                                  "rangeEnName": "Avg.DAU",
                                  "rangeCnName": "平均日活跃",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics DAU",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-u",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "PlatformCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "new_users",
                                  "enName": "New",
                                  "cnName": "新进用户",
                                  "rangeEnName": "New",
                                  "rangeCnName": "新进用户",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics New",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-plus",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "KeyMetricsCo",
              "className": "dbd-daily-card",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/overview_daily/card_metrics",
                  "mainMetricsList": [
                    "median_online_time",
                    "pcu",
                    "d1t1"
                  ],
                  "metricsList": [
                    "median_online_time",
                    "median_session_time",
                    "above_2hr_users",
                    "pcu",
                    "pcu_active_users_rate",
                    "acu",
                    "d1t1",
                    "d2t2",
                    "d7t7"
                  ]
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "median_online_time",
                                  "enName": "Median Playtime(h)",
                                  "cnName": "在线时长中位数(小时)",
                                  "rangeEnName": "Avg.Median Playtime(h)",
                                  "rangeCnName": "平均在线时长中位数(小时)",
                                  "preUnit": "",
                                  "endUnit": "H",
                                  "rainbowKey": "Pc V2 Metrics Playtime",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "pie-chart-icon",
                                  "position": ""
                                },
                                {
                                  "metricKey": "median_session_time",
                                  "enName": "Median Playtime Per Save(h)",
                                  "cnName": "单个存档在线时长(小时)",
                                  "rangeEnName": "Avg.Median Playtime Per Save(h)",
                                  "rangeCnName": "平均单个存档在线时长(小时)",
                                  "preUnit": "",
                                  "endUnit": "H",
                                  "rainbowKey": "Pc V2 Metrics Md.Playtime Per Save",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "user-session",
                                  "position": ""
                                },
                                {
                                  "metricKey": "above_2hr_users",
                                  "enName": "Playtime over 2h+ new users",
                                  "cnName": "在线时长2小时以上新进用户数",
                                  "rangeEnName": "Avg.Playtime over 2h+ new users",
                                  "rangeCnName": "平均在线时长2小时以上新进用户数",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics Playtime over 2h+ new users",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "pcu",
                                  "enName": "PCU",
                                  "cnName": "最高同时在线",
                                  "rangeEnName": "Avg.PCU",
                                  "rangeCnName": "日平均最高同时在线",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics PCU",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-pcu",
                                  "position": ""
                                },
                                {
                                  "metricKey": "pcu_active_users_rate",
                                  "enName": "PCU/DAU",
                                  "cnName": "最高同时在线/日活跃",
                                  "rangeEnName": "Avg.PCU/Avg.DAU",
                                  "rangeCnName": "平均最高同时在线/平均日活跃",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics PCU/DAU",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "",
                                  "position": ""
                                },
                                {
                                  "metricKey": "acu",
                                  "enName": "ACU",
                                  "cnName": "平均同时在线",
                                  "rangeEnName": "ACU",
                                  "rangeCnName": "平均同时在线",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc Metrics ACU",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "componentMetrics": [
                                {
                                  "metricKey": "d1t1",
                                  "enName": "D1(T-1)",
                                  "cnName": "次留(T-1)",
                                  "rangeEnName": "D1(T-1)",
                                  "rangeCnName": "次留(T-1)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc V2 Metrics D1(T-1)",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "user-success",
                                  "position": ""
                                },
                                {
                                  "metricKey": "d2t2",
                                  "enName": "D2(T-2)",
                                  "cnName": "2留(T-2)",
                                  "rangeEnName": "D2(T-2)",
                                  "rangeCnName": "2留(T-2)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc V2 Metrics D2(T-2)",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "user-success",
                                  "position": ""
                                },
                                {
                                  "metricKey": "d7t7",
                                  "enName": "D7(T-7)",
                                  "cnName": "7留(T-7)",
                                  "rangeEnName": "D7(T-7)",
                                  "rangeCnName": "7留(T-7)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "rainbowKey": "Pc V2 Metrics D7(T-7)",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "user-success",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "EventService",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "10px"
              },
              "props": {},
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "OverviewMetricsTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "renderIndex": 0,
                              "api": {
                                "metricsApi": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                                "dimensionApi": "/api/v1/dashboard/pc/overview_daily/dimension/metrics_trend"
                              },
                              "componentMetrics": [
                                {
                                  "enName": "DAU",
                                  "cnName": "日活跃",
                                  "metricKey": "active_users",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "New",
                                  "cnName": "新进用户",
                                  "metricKey": "new_users",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "D1",
                                  "cnName": "次留",
                                  "metricKey": "d1",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "D2",
                                  "cnName": "2留",
                                  "metricKey": "d2",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "D3",
                                  "cnName": "3留",
                                  "metricKey": "d3",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "D7",
                                  "cnName": "7留",
                                  "metricKey": "d7",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "TNU",
                                  "cnName": "总注册用户数",
                                  "metricKey": "total_users",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "PCU",
                                  "cnName": "最高同时在线",
                                  "metricKey": "pcu",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "ACU",
                                  "cnName": "平均同时在线",
                                  "metricKey": "acu",
                                  "type": "int",
                                  "decimal": 0
                                }
                              ]
                            }
                          }
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "OverviewMetricsTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "renderIndex": 1,
                              "excelFilterEnName": "Playtime Metrics",
                              "excelFilterCnName": "在线时长指标",
                              "api": {
                                "metricsApi": "/api/v1/dashboard/pc/overview_daily/metrics_trend",
                                "dimensionApi": "/api/v1/dashboard/pc/overview_daily/dimension/metrics_trend"
                              },
                              "componentMetrics": [
                                {
                                  "enName": "Median Playtime(h)",
                                  "cnName": "在线时长中位数(小时)",
                                  "metricKey": "median_online_time",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "Median Playtime Per Save(h)",
                                  "cnName": "单个存档在线时长(小时)",
                                  "metricKey": "median_session_time",
                                  "type": "decimals",
                                  "decimal": 2
                                }
                              ]
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "OverviewTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/overview_daily/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/overview_daily/overall_performance/download"
                  },
                  "componentMetrics": [
                    {
                      "metricKey": "total_users",
                      "reqMetricKey": "total_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 130,
                      "enName": "TNU",
                      "cnName": "总注册用户数",
                      "rainbowKey": "Pc TNU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "active_users",
                      "reqMetricKey": "active_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "DAU",
                      "cnName": "日活跃",
                      "rainbowKey": "Pc DAU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_users",
                      "reqMetricKey": "new_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "New",
                      "cnName": "新进用户",
                      "rainbowKey": "Pc New",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "d1",
                      "reqMetricKey": "d1",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D1",
                      "cnName": "次留",
                      "rainbowKey": "Pc D1",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d2",
                      "reqMetricKey": "d2",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D2",
                      "cnName": "2留",
                      "rainbowKey": "Pc D2",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d3",
                      "reqMetricKey": "d3",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D3",
                      "cnName": "3留",
                      "rainbowKey": "Pc D3",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d4",
                      "reqMetricKey": "d4",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D4",
                      "cnName": "4留",
                      "rainbowKey": "Pc D4",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d5",
                      "reqMetricKey": "d5",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D5",
                      "cnName": "5留",
                      "rainbowKey": "Pc D5",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d6",
                      "reqMetricKey": "d6",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D6",
                      "cnName": "6留",
                      "rainbowKey": "Pc D6",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d7",
                      "reqMetricKey": "d7",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D7",
                      "cnName": "7留",
                      "rainbowKey": "Pc D7",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d14",
                      "reqMetricKey": "d14",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D14",
                      "cnName": "14留",
                      "rainbowKey": "Pc D14",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d30",
                      "reqMetricKey": "d30",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D30",
                      "cnName": "30留",
                      "rainbowKey": "Pc D30",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "pcu",
                      "reqMetricKey": "pcu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 122,
                      "enName": "PCU",
                      "cnName": "最高同时在线",
                      "rainbowKey": "Pc Metrics PCU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "acu",
                      "reqMetricKey": "acu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 122,
                      "enName": "ACU",
                      "cnName": "平均同时在线",
                      "rainbowKey": "Pc Metrics ACU",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "median_online_time",
                      "reqMetricKey": "median_online_time",
                      "enPercentWidth": 175,
                      "cnPercentWidth": 175,
                      "enWidth": 175,
                      "cnWidth": 175,
                      "enName": "Median Playtime(h)",
                      "cnName": "在线时长中位数(小时)",
                      "rainbowKey": "Pc V2 Metrics Playtime",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "above_2hr_users",
                      "reqMetricKey": "above_2hr_users",
                      "enPercentWidth": 250,
                      "cnPercentWidth": 250,
                      "enWidth": 250,
                      "cnWidth": 250,
                      "enName": "Playtime over 2h+ new users",
                      "cnName": "在线时长2小时以上新进用户数",
                      "rainbowKey": "Pc V2 Metrics Playtime over 2h+ new users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "median_session_time",
                      "reqMetricKey": "median_session_time",
                      "enPercentWidth": 250,
                      "cnPercentWidth": 190,
                      "enWidth": 250,
                      "cnWidth": 190,
                      "enName": "Median Playtime Per Save(h)",
                      "cnName": "单个存档在线时长(小时)",
                      "rainbowKey": "Pc V2 Metrics Md.Playtime Per Save",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "retention_users",
                      "reqMetricKey": "retention_users",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 120,
                      "enWidth": 190,
                      "cnWidth": 120,
                      "enName": "DAU Retention Users",
                      "cnName": "日活留存",
                      "rainbowKey": "DAU Retention Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "churn_users",
                      "reqMetricKey": "churn_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 130,
                      "cnWidth": 100,
                      "enName": "Churn Users",
                      "cnName": "日流失",
                      "rainbowKey": "Churn Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "churn_rate",
                      "reqMetricKey": "churn_rate",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 80,
                      "cnWidth": 86,
                      "enName": "Churn%",
                      "cnName": "流失率",
                      "rainbowKey": "Churn%",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "return_users",
                      "reqMetricKey": "return_users",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 170,
                      "enWidth": 160,
                      "cnWidth": 95,
                      "enName": "DAU Return Users",
                      "cnName": "日回流",
                      "rainbowKey": "DAU Return Users",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "id": "breakdown",
      "tabName": "Daily Breakdown",
      "tabNameCN": "每日细分",
      "isHaveNotification": true,
      "notificationPath": "/overview/pcConsoleDailyV2",
      "path": "/overview/pcConsoleDailyV2/breakdown",
      "tabIcon": "pie-chart-icon",
      "logConfig": {
        "pageId": "204302",
        "pageName": "dailyV2Breakdown",
        "extInfo": "dailyV2Breakdown",
        "pagePath": "/overview/pcConsoleDailyV2/breakdown"
      },
      "filters": [
        {
          "name": "PcConsoleDailyFilterV2",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/pcConsoleDailyV2",
          "componentList": [
            {
              "name": "CommonRow",
              "className": "",
              "type": "layout",
              "style": {
                "marginTop": "10px"
              },
              "props": {},
              "children": [
                {
                  "name": "UserCompositionCo",
                  "className": "",
                  "type": "view",
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/overview_daily/metrics_users"
                    }
                  },
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "MetricsUserCompositionCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "timeType": "DAY",
                              "metricType": "dau"
                            }
                          }
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "MetricsUserCompositionCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "timeType": "DAY",
                              "metricType": "system"
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "CommonRow",
              "className": "",
              "type": "layout",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "RankListTabCo",
                  "className": "",
                  "style": {},
                  "type": "view",
                  "data": {
                    "regionDataType": "os"
                  },
                  "children": [
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_daily/country_region_platform",
                          "metric": "dau",
                          "haveCalBubble": false,
                          "isUserQuota": true,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    },
                    {
                      "name": "MetricsRankListCo",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/overview_daily/country_region_platform",
                          "metric": "new",
                          "haveCalBubble": false,
                          "isUserQuota": true,
                          "showConfig": {
                            "showTable": true,
                            "showChart": true
                          }
                        }
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "operationList": [ 
    { 
      "nameEn": "情报", 
      "nameCn": "Intelligence", 
      "url": "function(data) { const { unifiedid } = data; return '/intelligence/topCharts/pcGames/gamesDetails/' + unifiedid;  }"
    },
    { 
      "nameEn": "舆情", 
      "nameCn": "Opinions", 
      "url": "/opinion/Overview", 
      "params": { "gameid": "unifiedid" }, 
      "permission": "hasOpinionPermissions" 
    }, 
  ]
};